export const SET_INVOICE = 'payment:set-invoice';
export const FETCH_INVOICE = 'payment:fetch-invoice';
export const FETCH_INVOICE_SUCCESS = 'payment:fetch-invoice-success';
export const FETCH_INVOICE_FAIL = 'payment:fetch-invoice-fail';
export const ERROR_INVOICE = 'payment:error-invoice';
export const CREATE_PAYMENT_REQUEST = 'payment:create-payment-request';
export const SET_PAYMENT_REQUEST = 'payment:set-payment-request';
export const ERROR_PAYMENT_REQUEST = 'payment:error-payment-request';
export const CREATING_INVOICE_EMAIL = 'payment:creating-invoice-email';
export const SUCCESS_INVOICE_EMAIL = 'payment:success-invoice-email';
export const ERROR_INVOICE_EMAIL = 'payment:error-invoice-email';
export const SET_STATUS = 'payment:set-status';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/payment/action-types.js
 **/